import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class ChangePasswordViewModel {
    ShowAlert:      (pTitle: string, pMessage: string) => void;
    BackToSignIn:   ()                                 => void;
    NewLoading:     (pMessage: string)                 => dmLoading;

    mlText:         MLText;
    app:            mlBroker;
    ml:             mlBroker;
    Hotel:          dmHotel;
    LangID:         number;

    NewPassword:    string;
    ReTypePassword: string;

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: ()                                 => void
        ,pShowAlert:    (pTitle: string, pMessage: string) => void
        ,pNewLoading:   (pMessage: string)                 => dmLoading
    ) {
        this.mlText = pMLText;
        this.LangID = this.mlText.GetLangID();
        this.app    = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml     = this.mlText.GetBroker(
            'HotelAreaChangePassword'
        );

        this.Hotel          = pHotel;
        this.BackToSignIn   = pBackToSignIn;
        this.ShowAlert      = pShowAlert;
        this.NewLoading     = pNewLoading;

        this.NewPassword    = '';
        this.ReTypePassword = '';
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }

    public Save(): void {
        let changePassword = false;

        if (this.NewPassword != '') {
            changePassword = true;
        }

        if (!changePassword) { return; }

        if (this.NewPassword !== this.ReTypePassword) {
            this.NewPassword    = '';
            this.ReTypePassword = '';

            this.ShowAlert(
                this.app.Text(
                     'CantChangePassword'
                    ,'Can\'t Change Password'
                )
                ,this.app.Text(
                     'PasswordAndRetypedPassordMustMatch'
                    ,'Password and re-typed passord must match!'
                )
            );

            return;
        }

        if (changePassword && this.NewPassword.length < 8) {
            this.NewPassword    = '';
            this.ReTypePassword = '';

            this.ShowAlert(
                this.app.Text(
                     'CantChangePassword'
                    ,'Can\'t Change Password'
                )
                ,this.app.Text(
                     'PasswordMustBeMin8Chars'
                    ,'Password must be at least 8 characters in length!'
                )
            );

            return;
        }

        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        loading.Show(() => {
            let passwordParams = RQParam.PmsEditHotelPasswordParams();
            
            passwordParams.HotelID  = this.Hotel.HotelID;
            passwordParams.Password = this.NewPassword;
            passwordParams.LangID   = this.LangID;
            
            this.NewPassword    = '';
            this.ReTypePassword = '';
            
            RQService.Pms.EditHotelPassword(passwordParams).then(result => {
                let response = result as any;
            
                loading.Dismiss();

                this.ShowAlert(
                    this.app.Text(
                         'ChangePassword'
                        ,'Change Password'
                    )
                    ,this.app.Text(
                         'PasswordChangedOK'
                        ,'Password Changed OK'
                    )
                );
           
                if (changePassword) {
                    this.Hotel.Password = passwordParams.Password;
            
                    this.Hotel.PoliciesURI
                        = 'https://www.tobook.com/tool/policies/policyQuestionnaireOTA.asp?page=0&Login='
                        + this.Hotel.UserName
                        + '&Password='
                        + this.Hotel.Password;
                }
            });
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/change-password/xv-change-password.ts